import Grid from '@mui/material/Grid';
import { Fragment, useContext } from 'react';

import { CustomizationInfo } from './app/app-bar/CustomizationInfo';
import { OnboardingContainer } from './app/pages/onboarding/OnboardingContainer';
import { CompanyLogo } from './design/components/CompanyLogo';
import { Headline, SubTitle } from './design/components/Typography';
import { ApplicationContext } from '../../shared/source/context/context';

import type { FunctionComponent } from 'react';

export const AccessDeniedPage: FunctionComponent = () => {
    const { translate } = useContext(ApplicationContext);

    return (
        <Fragment>
            <CustomizationInfo />
            <OnboardingContainer>
                <Grid alignItems="center" container={true} direction="column" mb={8} mt={11} rowGap={1.5}>
                    <Grid>
                        <CompanyLogo />
                    </Grid>
                    <Grid>
                        <Headline variant="h4">{translate('pages.denied-page.title')}</Headline>
                    </Grid>
                    <Grid mb={5.5}>
                        <SubTitle>{translate('pages.denied-page.subtitle')}</SubTitle>
                    </Grid>
                </Grid>
            </OnboardingContainer>
        </Fragment>
    );
};
